import RetryFunction, { RetryAction } from 'utils/retry/RetryFunction';
import ExponentialRetryPolicy, {
    ExponentialRetryPolicyOptions,
} from 'utils/retry/ExponentialRetryPolicy';

export interface ExponentialRetryOptions
    extends Partial<ExponentialRetryPolicyOptions> {
    action: RetryAction;
}

export function exponentialRetryFunction(options: ExponentialRetryOptions) {
    return new RetryFunction({
        action: options.action,
        retryPolicy: new ExponentialRetryPolicy(options),
        retryLog: options.retryLog,
    });
}

export function exponentialRetry(options: ExponentialRetryOptions) {
    return () => exponentialRetryFunction(options).exec();
}

export const useExponentialRetry = (options: ExponentialRetryOptions) =>
    exponentialRetry(options);
